<template>
  <div>
    <div
      class="b-select-btn"
      :class="{ 'is-fit': fit }"
    >
      <div
        v-for="(item, index) in items"
        :key="`selectBtn-${index}`"
        class="select-btn-wrapper"
      >
        <BBtn
          v-bind="btnAttributes(item.value)"
          :fit="fit"
          :round="round"
          :size="size"
          @click="() => handleStatus(item.value)"
        >
          <span>{{ item.text }}</span>
        </BBtn>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
type TSelectButtonItem = {
  value: string;
  text: string;
};

type TButtonAttributes = {
  type: 'primary' | 'default';
  disabled: boolean;
};

type TProps = {
  items: TSelectButtonItem[];
  disabledValue?: string[];
  fit?: boolean;
  round?: boolean;
  size?: 'mini' | 'small' | 'medium';
};

const props = withDefaults(defineProps<TProps>(), {
  disabledValue: () => [],
  fit: false,
  round: false,
  size: 'medium',
});

const modelValue = defineModel<string>();

const btnAttributes = (value: string): TButtonAttributes => {
  return {
    type: isSelected(value) ? 'primary' : 'default',
    disabled: isDisabled(value),
  };
};

const isSelected = (value: string): boolean => {
  return modelValue.value === value;
};

const isDisabled = (value: string): boolean => {
  return props.disabledValue.includes(value);
};

const handleStatus = (newValue: string): void => {
  modelValue.value = newValue;
};
</script>

<style lang="scss" scoped>
.b-select-btn {
  @include m-flex-align-center;

  margin: -4px;

  &.is-fit {
    width: calc(100% + 8px);

    .select-btn-wrapper {
      flex: 1;
    }
  }
}

.select-btn-wrapper {
  padding: 4px;
}
</style>
